var _style, _path, _g, _g2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _polygon, _g3, _polygon2, _polygon3, _polygon4, _rect7, _rect8, _rect9, _path2, _path3, _g4, _ellipse, _path4, _path5, _path6, _ellipse2, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _polygon5, _polygon6, _polygon7, _g5, _circle, _circle2, _rect10, _rect11, _rect12, _g6, _g7, _ellipse3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 390.1 243.1",
    style: {
      enableBackground: "new 0 0 390.1 243.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.15;fill:#7AAAE6;}\n\t.st1{fill:#B4D2FF;}\n\t.st2{fill:#D8E4FA;}\n\t.st3{fill:#7AAAE6;}\n\t.st4{fill:#9E1A37;}\n\t.st5{fill:#F04B68;}\n\t.st6{fill:#B1D2FD;}\n\t.st7{fill:#7AA9E3;}\n\t.st8{fill:#FFFFFF;}\n\t.st9{fill:#F5A626;}\n\t.st10{fill:#D87708;}\n\t.st11{fill:#CA2847;}\n\t.st12{fill:#E8546C;}\n\t.st13{fill:#D9435B;}\n\t.st14{fill:#040549;}\n\t.st15{fill:#AED1FF;}\n\t.st16{fill:#204476;}\n\t.st17{fill:#D690B6;}\n\t.st18{fill:#F5A7BE;}\n\t.st19{fill:none;}\n\t.st20{fill:#FF94AE;}\n\t.st21{fill:#FFBC4A;}\n\t.st22{fill:#EB9C14;}\n\t.st23{fill:#A5A8A6;}\n\t.st24{fill:#C4CAD1;}\n\t.st25{fill:#FCA805;}\n\t.st26{fill:#FFC35D;}\n\t.st27{fill:#1B42A0;stroke:#FFFFFF;stroke-width:0.3;stroke-miterlimit:10;}\n\t.st28{fill:#9E1A37;stroke:#FFFFFF;stroke-width:0.3;stroke-miterlimit:10;}\n\t.st29{fill:#F07287;}\n\t.st30{fill:#E84E68;}\n\t.st31{fill:#B5D4E5;}\n\t.st32{fill:#DCE9FF;}\n\t.st33{fill:#B9CEEE;}\n\t.st34{fill:#F9B452;}\n\t.st35{fill:#F89D29;}\n\t.st36{fill:#ED7F31;}\n\t.st37{fill:#FAFFFF;}\n\t.st38{fill:#020147;}\n\t.st39{fill:#106FB7;}\n\t.st40{opacity:0.49;}\n\t.st41{clip-path:url(#SVGID_00000062165645343657158820000013984959781602688157_);fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.7,227.4c0,0-31.8-4.6-38.9-30.7S4,144.3,31.3,128.7s36.4-16.9,61.9-37.4S145.3,22,212.1,21.9 c57.5-0.1,82.9,16,106,35.2c18.5,15.3,47.7,52.5,38.5,103.8c-9.6,53.3-37.1,64.6-37.1,64.6L50.7,227.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M368.2,172.8c0,0-3.6,2.6-4.7,5.6s-1.4,6.3-1.4,6.3s3.6-3.1,4.8-5C368.1,177.7,368.2,172.8,368.2,172.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M376.1,187.8c0,0-3.6-2.9-7-3.2c-3.3-0.3-6.7,0.3-6.7,0.3s4.2,2.8,6.5,3.5 C371.2,189.1,376.1,187.8,376.1,187.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M371.8,191.7c0,0-3.3-3.3-6.6-3.9s-6.7-0.3-6.7-0.3s3.9,3.2,6.1,4.1C366.7,192.5,371.8,191.7,371.8,191.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M366.8,196.1c0,0-2.8-3.8-5.9-4.9s-6.6-1.4-6.6-1.4s3.4,3.8,5.4,5S366.8,196.1,366.8,196.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M361.5,199.2c0,0-2.6-3.6-5.7-4.6c-3-1.1-6.3-1.3-6.3-1.3s3.2,3.6,5.1,4.8 C356.6,199.2,361.5,199.2,361.5,199.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M379.6,177c0,0-6.2-0.3-9.9,1.9c-3.6,2.2-6.8,5.2-6.8,5.2s5.5-0.4,9.5-2C375.4,181,379.6,177,379.6,177z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315.4,218.8l-0.4-0.5c22.6-19.1,48.9-34.7,49.1-34.8l0.4,0.6C364.2,184.2,337.9,199.8,315.4,218.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M344.9,196.2c0,0,5.2-0.4,8.5,2.4c3.3,2.8,5.3,5.6,5.3,5.6s-5.7-0.7-7.8-2.3S348.6,198.1,344.9,196.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M340.8,199.2c0,0,1.1,2.2,4.3,5.5s6.6,4.2,6.6,4.2s-0.6-4.2-3.2-6.4C346.1,200.3,340.8,199.2,340.8,199.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M338.4,201.1c0,0,0.7,3.1,2.6,5.6c1.8,2.4,5.6,4.6,5.6,4.6s-1-4-2.9-6S338.4,201.1,338.4,201.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M333.4,204.2c0,0,0.2,2.9,2.5,6.1c2.3,3.2,5.5,5.2,5.5,5.2s0.7-3.7-1.7-6.2S336.6,208.1,333.4,204.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M326,209.8c0,0,1.2,3.3,4.5,5.1c3.2,1.8,7,1.9,7,1.9s-2-3.5-4-4.8C331.4,210.7,329.6,212.1,326,209.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M322,213.4c0,0,1,4.4,3.4,5.9c2.4,1.6,6.3,1.9,6.3,1.9s-1.3-3.3-3.4-4.9S322,213.4,322,213.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M360.6,175.6c0,0-3.3,2.9-4.2,5.2c-0.9,2.3-0.9,7.9-0.9,7.9s2-4.9,3.6-6C360.8,181.7,360.8,176.4,360.6,175.6z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M352.5,177c0,0-2.9,3.8-3,6.7c0,2.9,0.9,8.3,0.9,8.3s2.7-5.1,2.8-7S352.5,177,352.5,177z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M345.5,179.2c0,0-2.1,5.1-1.7,7.6s2.6,8.1,2.6,8.1s1.8-4.4,1.6-7.1S345.5,179.2,345.5,179.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M339.7,184.6c0,0-2,3.3-1.3,6.4c0.7,3,3.4,6.9,3.4,6.9s1-3.1,0.7-6.4C342.2,188.1,339.7,184.6,339.7,184.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M333.4,191c0,0-0.6,2.7,0,5.2s2.9,5.9,2.9,5.9s1.3-3.7,0.8-6.4S333.4,191,333.4,191z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M328.1,192c0,0-1.4,4.9,0,8.2c1.4,3.3,3.6,5.3,3.6,5.3s1-1.6,0-6.7S328.1,192,328.1,192z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M324.5,196.9c0,0-1.6,4.5,0,6.8c1.6,2.3,3.5,4.2,3.5,4.2s1.1-1.6,0-5.3C326.8,199,326.4,201.2,324.5,196.9z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M323.1,119.6l13.3,13.5l-10-18.6c0,0,16.3-12.9,21.9-12.7l6.3,8.7V98.9c0,0,13.5-6.5,23.4-7.7 c0,0-0.6,15.9-0.8,19.2l-10.4,2.6l9.4,3c0,0-5,23.4-9.5,33.4c0,0-13.2-3.2-24.5-1.9c0,0,16.2,5.3,20.7,9.6c0,0-10.2,18.8-15.3,25.3 c0,0-11-3.5-19.7-3.5c-8.8,0-8.8,0-8.8,0c8.8,0,20.6,9.5,20.6,9.5s-14.5,15.7-24.9,18.3l8.4-86.4V119.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M314.4,179.5l-0.9-0.5c12.1-23.4,59.2-81.9,59.7-82.5l0.8,0.7C373.5,97.8,326.4,156.2,314.4,179.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M361.8,111.8l0.4-1.1c0.9-2.5-0.7-9.9-1.4-12.6l1-0.3c0.1,0.4,2.2,8.3,1.6,12.2c2.4-0.8,8.9-2.8,13.5-1.2 l-0.3,1c-5.2-1.8-13.6,1.5-13.7,1.5L361.8,111.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M373,124.6c-4.5-4-19.1-2.9-19.3-2.8l-0.4,0l-0.1-0.4c-3.1-9.2-8.4-16.6-8.4-16.7l0.9-0.6 c0.1,0.1,5.3,7.4,8.4,16.6c2.5-0.2,15.2-0.8,19.6,3.1L373,124.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M371.8,130.9c-10.5-6.2-21.2-4.8-21.3-4.8l-0.6,0.1l0-0.6c0.4-6.7-10.1-18.7-10.2-18.8l0.8-0.7 c0.4,0.5,10.3,11.8,10.4,18.9c2.5-0.2,12-0.5,21.4,5L371.8,130.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M368.7,143.2c-13.1-7.6-23.7-8.1-23.8-8.1l-0.4,0l-0.1-0.3c-4-11.1-13.9-22.7-14-22.8l0.8-0.7 c0.1,0.1,9.9,11.7,14.1,22.8c2,0.2,11.9,1.2,23.9,8.2L368.7,143.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M360.2,161.7c-12.1-8.8-28.6-9.9-28.8-10l-0.4,0l-0.1-0.4c-0.6-3.8-8-12.9-8.1-13l0.8-0.7 c0.3,0.4,7.3,8.8,8.2,13.1c2.7,0.2,17.7,1.9,28.9,10.1L360.2,161.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M356.5,168.4c-13.7-8.5-23.9-8.1-28.2-7.9c-1.7,0.1-2.5,0.1-3-0.3c-0.2-0.2-0.3-0.4-0.3-0.6 c0-1.2-2.2-3.6-3.6-4.9l0.7-0.8c0.4,0.4,3.8,3.5,3.9,5.5c0.3,0.1,1.2,0.1,2.1,0c4.5-0.2,14.9-0.6,28.8,8.1L356.5,168.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M347.4,182.5c-0.1-0.1-11.1-6.3-27.3-6.5l0-1c16.5,0.2,27.7,6.6,27.9,6.6L347.4,182.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M336.8,193c0-0.1-3.5-5-16.8-8.2l0.2-1c13.8,3.3,17.3,8.5,17.5,8.7L336.8,193z"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 293.3,
    y: 113.8,
    className: "st4",
    width: 4.3,
    height: 115.9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 297.6,
    y: 113.8,
    className: "st5",
    width: 27.4,
    height: 115.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 266.5,
    y: 113.8,
    className: "st6",
    width: 26.8,
    height: 115.9
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 238.9,
    y: 113.8,
    className: "st7",
    width: 27.7,
    height: 115.9
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 303.4,
    y: 144.4,
    className: "st8",
    width: 16.6,
    height: 8
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 303.4,
    y: 155.5,
    className: "st8",
    width: 16.6,
    height: 64.5
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "71.6,106.8 79.9,106.8 84.3,122.4 76.2,122.4 "
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M20.7,118.8c0,0,2,7.2,5.3,11.2c4.4,5.3,9.3,7.7,9.3,7.7s-0.7-5.9-4.7-11S20.7,118.8,20.7,118.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M17.6,135.8c0,0,4.9,4,9.3,5.1c5.9,1.4,10.8,0.6,10.8,0.6s-3.2-3.8-8.7-5.3S17.6,135.8,17.6,135.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M39.4,118.8c0,0-3.2,6.6-3.1,11.9c0.1,7.1,2.5,12.5,2.5,12.5s3.3-4.6,3.5-11.3 C42.4,125.3,39.4,118.8,39.4,118.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M48,129.8c0,0-3.8,5.4-4.5,10.1c-1,6.2,0.3,11.2,0.3,11.2s3.6-3.7,4.8-9.5C49.6,135.8,48,129.8,48,129.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M57.9,137c0,0-5.4,4.2-7.7,8.4c-3,5.6-3.3,10.7-3.3,10.7s4.7-2.6,7.7-7.8S57.9,137,57.9,137z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M20.7,144.3c0,0,5.3,3.5,9.8,4.1c6,0.8,10.8-0.5,10.8-0.5s-3.6-3.4-9.2-4.4C26.5,142.6,20.7,144.3,20.7,144.3z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M24.9,153c0,0,5.5,2.8,9.8,2.9c5.8,0.2,10.1-1.6,10.1-1.6s-3.9-2.9-9.3-3.2C30.1,150.8,24.9,153,24.9,153z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M27.8,160.6c0,0,5.7,2.7,10.3,2.7c6.2-0.1,10.9-2.2,10.9-2.2s-4-2.9-9.8-3C33.5,158,27.8,160.6,27.8,160.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M29.9,168.2c0,0,6,2.6,10.7,2.4c6.3-0.2,10.9-2.5,10.9-2.5s-4.3-2.8-10.2-2.8S29.9,168.2,29.9,168.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M33.7,180.3c0,0,10.2-10.1,16.5-7.6v5C50.2,177.8,46.2,179.6,33.7,180.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M37.8,186.7c0,0,10.2-10.1,16.5-7.6v5C54.3,184.2,50.3,186,37.8,186.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M41.3,195.8c0,0,8.1-11.2,14-9.4l0.6,5C55.9,191.4,52.5,193.7,41.3,195.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M33.7,136c0,0,15.9,25.2,19.3,31.6c3.4,6.4,3.4,6.4,3.4,6.4c0-4.9-4.9-10.7-4.9-10.7l-17.8-29.2V136z"
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "60.7,154.6 52.4,154.6 62.8,229.3 72.3,229.7 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "105,118.8 69.6,118.8 85.1,229.3 105,229.7 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "82.3,130.7 107.5,130.7 106.4,167.7 87.6,167.7 "
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 102.1,
    y: 63.3,
    className: "st11",
    width: 18.3,
    height: 166.4
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 120.4,
    y: 63.3,
    className: "st12",
    width: 121.1,
    height: 166.4
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 82.8,
    className: "st13",
    width: 106.8,
    height: 54.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M226.4,189.8c0,0-0.3,7.5,0,17.3c0.3,9.8,1.1,18.9,1.1,18.9s-3.6,1-4,2.1c-0.4,1.1,0,1.4,0,1.4h7.3 c0,0,1-1.1,0.8-1.9c-0.2-0.8,2.4-24.4,2.5-25.4c0.1-1,1.2-1.9,1.4-0.4s2.1,9.1,3,11.7c1.5,4.5,2.9,10,3.6,11.6 c0.7,1.5,0,2.7-1.2,3.2s-1.6,1.2-1.6,1.2h2.1h4.8c0,0-1.4-10.1-1.8-17.8c-0.4-7.7-2.2-23.3-2.2-23.3L226.4,189.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M234.3,165.4c0,0-2.8,0.2-4.7,1.7c-1.9,1.5-3.8,3.7-3.8,3.7l-7.2-11.2c0,0-0.3,3.4,0,5.9c0.3,2.5,1.9,6.7,3,8.2 s4.8,2.4,4.8,2.4v13.8c0,0,5,2.6,7.9,2.1c2.9-0.5,8.3-2.1,8.3-2.1V187c0,0,4.7-2.7,5.7-4.1c1-1.4,2.3-3.5,0.9-7.1 c-1.4-3.7-3.6-6.5-5-8C242.8,166.3,240.8,165.5,234.3,165.4z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M164,100c0,1.9-0.5,3.3-1.4,4.3c-0.9,1-2.2,1.5-4,1.5c-1.7,0-3-0.5-4-1.5c-0.9-1-1.4-2.4-1.4-4.3 s0.5-3.3,1.4-4.3c0.9-1,2.3-1.5,4-1.5c1.7,0,3,0.5,4,1.5C163.5,96.7,164,98.1,164,100z M155.8,100c0,1.3,0.2,2.2,0.7,2.8 s1.2,1,2.1,1c1.9,0,2.9-1.3,2.9-3.8c0-2.5-0.9-3.8-2.8-3.8c-0.9,0-1.7,0.3-2.1,1C156,97.7,155.8,98.7,155.8,100z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M175.6,99.9c0,1.9-0.5,3.3-1.6,4.3s-2.6,1.5-4.6,1.5h-3.2V94.3h3.5c1.8,0,3.3,0.5,4.3,1.5 C175.1,96.8,175.6,98.1,175.6,99.9z M173.2,99.9c0-2.4-1.1-3.6-3.2-3.6h-1.3v7.3h1C172,103.6,173.2,102.4,173.2,99.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M178,105.6V94.3h2.4v11.2H178z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M189.8,102.5c0,1-0.4,1.8-1.1,2.4c-0.7,0.6-1.7,0.9-3,0.9c-1.2,0-2.3-0.2-3.2-0.7v-2.2 c0.8,0.3,1.4,0.6,1.9,0.7c0.5,0.1,1,0.2,1.4,0.2c0.5,0,0.9-0.1,1.2-0.3s0.4-0.5,0.4-0.9c0-0.2-0.1-0.4-0.2-0.6 c-0.1-0.2-0.3-0.3-0.5-0.5c-0.2-0.2-0.7-0.4-1.5-0.8c-0.7-0.3-1.2-0.6-1.5-0.9c-0.3-0.3-0.6-0.6-0.8-1c-0.2-0.4-0.3-0.9-0.3-1.4 c0-1,0.3-1.8,1-2.3c0.7-0.6,1.6-0.9,2.8-0.9c0.6,0,1.1,0.1,1.7,0.2s1.1,0.3,1.7,0.6l-0.8,1.9c-0.6-0.2-1.1-0.4-1.5-0.5 c-0.4-0.1-0.8-0.1-1.2-0.1c-0.5,0-0.8,0.1-1,0.3c-0.2,0.2-0.4,0.5-0.4,0.8c0,0.2,0,0.4,0.1,0.5s0.3,0.3,0.5,0.5 c0.2,0.1,0.7,0.4,1.5,0.8c1,0.5,1.8,1,2.2,1.5C189.6,101.1,189.8,101.7,189.8,102.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M198.3,105.6h-6.5V94.3h6.5v2h-4.1v2.5h3.8v2h-3.8v2.9h4.1V105.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M207.5,105.6l-0.8-2.7h-4.1l-0.8,2.7h-2.6l4-11.3h2.9l4,11.3H207.5z M206.2,100.9c-0.8-2.4-1.2-3.8-1.3-4.1 c-0.1-0.3-0.2-0.6-0.2-0.8c-0.2,0.7-0.7,2.3-1.5,4.9H206.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M152.3,123l-2.7-8.8h-0.1c0.1,1.8,0.1,3,0.1,3.6v5.2h-2.1v-11.2h3.2l2.7,8.6h0l2.8-8.6h3.2V123h-2.2v-5.3 c0-0.3,0-0.5,0-0.9s0-1.2,0.1-2.6h-0.1l-2.9,8.8H152.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M169.3,123l-0.8-2.7h-4.1l-0.8,2.7H161l4-11.3h2.9l4,11.3H169.3z M167.9,118.4c-0.8-2.4-1.2-3.8-1.3-4.1 c-0.1-0.3-0.2-0.6-0.2-0.8c-0.2,0.7-0.7,2.3-1.5,4.9H167.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M183.2,123h-3l-4.9-8.5h-0.1c0.1,1.5,0.1,2.6,0.1,3.2v5.3h-2.1v-11.2h3l4.9,8.4h0.1c-0.1-1.5-0.1-2.5-0.1-3.1 v-5.3h2.1V123z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M195.2,111.8v7.3c0,0.8-0.2,1.6-0.6,2.2c-0.4,0.6-0.9,1.1-1.6,1.4s-1.5,0.5-2.5,0.5c-1.4,0-2.6-0.4-3.4-1.1 c-0.8-0.7-1.2-1.8-1.2-3v-7.2h2.4v6.9c0,0.9,0.2,1.5,0.5,1.9c0.3,0.4,0.9,0.6,1.7,0.6c0.8,0,1.3-0.2,1.7-0.6c0.4-0.4,0.5-1,0.5-1.9 v-6.9H195.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M204.9,123l-0.8-2.7h-4.1l-0.8,2.7h-2.6l4-11.3h2.9l4,11.3H204.9z M203.5,118.4c-0.8-2.4-1.2-3.8-1.3-4.1 c-0.1-0.3-0.2-0.6-0.2-0.8c-0.2,0.7-0.7,2.3-1.5,4.9H203.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M208.8,123v-11.2h2.4v9.3h4.6v2H208.8z"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8248 -0.5654 0.5654 0.8248 -46.6321 143.9755)",
    className: "st14",
    cx: 209,
    cy: 147.2,
    rx: 12.5,
    ry: 16.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M206.9,134.4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M241.9,195.7c-1.5,0.9-2.6-0.7-2.6-0.7c-0.9-2.2-25.4-38.6-25.4-38.6l3.1-2.1l25.5,38.7 C242.5,193.1,243.4,194.7,241.9,195.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M242.4,194.7c-1.5,0.9-2.6-0.7-2.6-0.7c-0.9-2.2-25.4-38.6-25.4-38.6l3.1-2.1l25.5,38.7 C243.1,192.1,244,193.7,242.4,194.7z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8248 -0.5654 0.5654 0.8248 -46.164 144.3568)",
    className: "st16",
    cx: 209.9,
    cy: 146.7,
    rx: 12.6,
    ry: 16.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M234,163.5l-0.3,3.6c0,0,0.2,1.2,0.9,1.5c0.7,0.3,1.8,0.4,2.2,0s1.1-0.8,1.2-1.8c0.1-1,0-3.8,0-3.8L234,163.5z "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M232.5,157.4c0,0-1.1,2.6-0.5,4.9c0.6,2.3,1.8,2.7,2.6,2.9c0.7,0.2,4.2,0.3,4.7-2.5c0.5-2.7-0.6-5.3-1.6-5.6 S232.5,157.4,232.5,157.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M236,154.6c0,0-4.3-0.2-4.4,1.6c-0.1,1.9,1.1,2.8,3.9,3.1c2.8,0.3,2.7,3.1,2.7,3.4c0,0.3,0.6,0.9,1.5,0.9 c0.9,0,2.6-3.1,1.4-5.4C239.9,155.8,238,154.5,236,154.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M242.2,175.7v7c0,0,2.2-2,2.2-3.5S243.5,176.6,242.2,175.7z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M144.3,146h43.3v43.3h-43.3V146z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M178.9,169.3c0.1-0.5,0.1-1.1,0.1-1.7c0-0.6,0-1.2-0.1-1.7l3.7-2.9c0.3-0.3,0.4-0.7,0.2-1.1l-3.5-6 c-0.2-0.4-0.7-0.5-1.1-0.4l-4.3,1.7c-0.9-0.7-1.9-1.3-2.9-1.7l-0.7-4.6c-0.1-0.4-0.4-0.7-0.9-0.7h-6.9c-0.4,0-0.8,0.3-0.8,0.7 l-0.7,4.6c-1.1,0.4-2,1-2.9,1.7l-4.3-1.7c-0.4-0.1-0.8,0-1.1,0.4l-3.4,6c-0.2,0.4-0.1,0.8,0.2,1.1l3.7,2.9c-0.1,0.5-0.2,1.1-0.2,1.7 c0,0.6,0,1.2,0.1,1.7l-3.7,2.9c-0.3,0.3-0.4,0.7-0.2,1.1l3.5,6c0.2,0.4,0.7,0.5,1.1,0.4l4.3-1.7c0.9,0.7,1.9,1.3,2.9,1.7l0.7,4.6 c0.1,0.4,0.4,0.7,0.9,0.7h6.9c0.4,0,0.8-0.3,0.8-0.7l0.7-4.6c1.1-0.4,2-1,2.9-1.7l4.3,1.7c0.4,0.1,0.8,0,1.1-0.4l3.5-6 c0.2-0.4,0.1-0.8-0.2-1.1L178.9,169.3z M166,174.2c-3.6,0-6.5-2.9-6.5-6.5s2.9-6.5,6.5-6.5s6.5,2.9,6.5,6.5S169.6,174.2,166,174.2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M180,171.3h26.9v26.9H180V171.3z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M201.4,185.7c0-0.3,0.1-0.7,0.1-1.1c0-0.4,0-0.7-0.1-1.1l2.3-1.8c0.2-0.2,0.3-0.5,0.1-0.7l-2.1-3.7 c-0.1-0.2-0.4-0.3-0.7-0.2l-2.7,1.1c-0.6-0.4-1.2-0.8-1.8-1.1l-0.4-2.8c0-0.3-0.3-0.5-0.5-0.5h-4.3c-0.3,0-0.5,0.2-0.5,0.5l-0.4,2.8 c-0.7,0.3-1.3,0.6-1.8,1.1l-2.7-1.1c-0.2-0.1-0.5,0-0.7,0.2l-2.1,3.7c-0.1,0.2-0.1,0.5,0.1,0.7l2.3,1.8c-0.1,0.3-0.1,0.7-0.1,1.1 c0,0.3,0,0.7,0.1,1.1l-2.3,1.8c-0.2,0.2-0.3,0.5-0.1,0.7l2.1,3.7c0.1,0.2,0.4,0.3,0.7,0.2l2.7-1.1c0.6,0.4,1.2,0.8,1.8,1.1l0.4,2.8 c0.1,0.3,0.3,0.5,0.5,0.5h4.3c0.3,0,0.5-0.2,0.5-0.5l0.4-2.8c0.7-0.3,1.3-0.6,1.8-1.1l2.7,1.1c0.2,0.1,0.5,0,0.7-0.2l2.1-3.7 c0.1-0.2,0.1-0.5-0.1-0.7L201.4,185.7z M193.4,188.7c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S195.7,188.7,193.4,188.7z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "59.2,118.8 69.9,118.8 85.4,229.3 75,229.3 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "55.4,122.1 59.6,118.8 75.3,229.3 71.2,229.3 "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "52.9,154.6 49.9,157 49.9,229.3 63.3,229.3 "
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 262.1,
    y: 100.9,
    className: "st23",
    width: 11.9,
    height: 12.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.7,
    y: 104.8,
    className: "st24",
    width: 16.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.7,
    y: 110,
    className: "st24",
    width: 16.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M268.7,102.2c0,0,2.5,0,4.7,0s2.4-1.5,2.8-2.7c5.1-13.6,15.2-16.9,13.8-29.4c-2.4-20.6-21.4-19.7-21.4-19.7 h-1.3c0,0-19-0.9-21.4,19.7c-1.4,12.5,8.7,15.8,13.8,29.4c0.4,1.2,0.6,2.7,2.8,2.7c2.2,0,4.7,0,4.7,0H268.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st26",
    cx: 268,
    cy: 71.5,
    r: 15.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M260.3,54.2c0,0,1.5-0.7,2.1,0.4c0.9,1.5-0.6,2.4-0.6,2.4s-2,0.7-5.5,4.2c-2.6,2.6-3.3,6-3.3,6 s-0.5,1.4-1.7,1.1c-1.8-0.5-1.3-1.8-1.3-1.8s1.1-4.1,3.4-7C256.9,55.3,260.3,54.2,260.3,54.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M286.2,75.3c0,0-0.7,1.7-1.8,1.2c-1.6-0.7-1-2.3-1-2.3s0.3-1.7,0.3-3.1c0-1.4-0.2-2.2-0.2-2.2 s-0.5-1.4,0.7-1.9c1.7-0.7,2.2,1,2.2,1s0.2,2.2,0.2,3.3C286.7,73.8,286.2,75.3,286.2,75.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M270.3,102.2c0-0.2-0.2-11.8-0.3-18.7h-4.3v18.6h-0.7V83.5h-2.6c-2.4,0-3.3-2.3-3.3-2.3l0-0.1l0-3 c0,0-0.1-1.3,0.7-2.2c0.6-0.6,1.4-0.9,2.5-0.9c3.4,0,3.5,3.4,3.5,3.5v4.4h4.2c0-2.1,0-3.6,0-4.1c0-2.6,1.1-3.8,3.6-3.8 c2.9,0,3.2,1.1,3.2,4.4c0,3.5-2.2,4.2-2.3,4.2l-0.1,0h-3.6c0.1,6.9,0.2,18.5,0.2,18.6L270.3,102.2z M270.8,82.8h3.6 c0.3-0.1,1.8-0.8,1.8-3.5c0-3.2-0.3-3.7-2.5-3.7c-2.1,0-2.9,0.9-2.9,3.1C270.7,79.2,270.7,80.8,270.8,82.8z M259.9,81 c0.1,0.3,0.8,1.8,2.6,1.8h2.6v-4.4c0-0.1,0-2.8-2.8-2.8c-0.9,0-1.5,0.2-1.9,0.7c-0.6,0.7-0.5,1.7-0.5,1.7L259.9,81z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M266,44.2h1.7c0.2,0,0.3-0.1,0.3-0.3v-7.2c0-0.2-0.1-0.3-0.3-0.3H266c-0.2,0-0.3,0.1-0.3,0.3v7.2 C265.8,44.1,265.9,44.2,266,44.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M280.1,47.7l1.4,0.8c0.1,0.1,0.3,0,0.4-0.1l3.6-6.3c0.1-0.1,0-0.3-0.1-0.4l-1.4-0.8c-0.1-0.1-0.3,0-0.4,0.1 l-3.6,6.3C280,47.4,280,47.6,280.1,47.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M290.5,57.3l0.8,1.4c0.1,0.1,0.2,0.2,0.4,0.1l6.3-3.6c0.1-0.1,0.2-0.2,0.1-0.4l-0.8-1.4 c-0.1-0.1-0.2-0.2-0.4-0.1l-6.3,3.6C290.5,57,290.5,57.2,290.5,57.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M295.2,71.4V73c0,0.2,0.1,0.3,0.3,0.3h7.2c0.2,0,0.3-0.1,0.3-0.3v-1.7c0-0.2-0.1-0.3-0.3-0.3h-7.2 C295.3,71.1,295.2,71.2,295.2,71.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M252.3,48.2l1.4-0.8c0.1-0.1,0.2-0.2,0.1-0.4l-3.6-6.3c-0.1-0.1-0.2-0.2-0.4-0.1l-1.4,0.8 c-0.1,0.1-0.2,0.2-0.1,0.4l3.6,6.3C252,48.3,252.2,48.3,252.3,48.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M242.5,59l0.8-1.4c0.1-0.1,0-0.3-0.1-0.4l-6.3-3.6c-0.1-0.1-0.3,0-0.4,0.1l-0.8,1.4c-0.1,0.1,0,0.3,0.1,0.4 l6.3,3.6C242.3,59.1,242.4,59.1,242.5,59z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 279.9,
    cy: 129.9,
    r: 8.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st28",
    cx: 311,
    cy: 129.9,
    r: 8.6
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 271.4,
    y: 144.4,
    className: "st8",
    width: 16.6,
    height: 8
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 271.4,
    y: 155.5,
    className: "st8",
    width: 16.6,
    height: 64.5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 22.4,
    y: 228.9,
    className: "st23",
    width: 334.6,
    height: 1.6
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M102.1,228.9h-3.5c-3.9,0-7-3.2-7-7v-5.5c0-3.9,3.2-7,7-7h3.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M102.1,214.9c-5.3,0.3-9.6-1.1-10.6,3.2v-1.7c0-3.9,3.2-7,7-7h3.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 102.1,
    y: 209.3,
    className: "st31",
    width: 4.1,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.1,
    y: 214.9,
    className: "st32",
    width: 4.1,
    height: 9.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.1,
    y: 224,
    className: "st33",
    width: 4.1,
    height: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 106.2,
    y: 209.3,
    className: "st34",
    width: 76.2,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.2,
    y: 214.9,
    className: "st35",
    width: 76.2,
    height: 9.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.2,
    y: 224,
    className: "st36",
    width: 76.2,
    height: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "195.3,215.4 194.9,215.2 182.4,209.3 182.4,214.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "182.4,228.9 195.3,222.9 182.4,224  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "182.4,214.9 195.3,215.4 195.3,222.9 182.4,224  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "195.3,215.4 203.4,219.1 195.3,222.9  "
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M135.2,201.4h4.2c0,0,1.7,0.1,2.1,1.4c0.4,1.3,4.2,13.7,4.7,13.8c0.4,0.1,3.5,0.9,3.5,0.9s-3.2,2.2-4,1.4 c-0.8-0.8-3.2-5.8-4.2-6.9c-1-1.1-4.3-4.1-5.1-5.3c-0.8-1.2-8.7-1.8-8.7-1.8L135.2,201.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M125.4,210c0,0,8,0,8.3,0c0.3,0-0.2,5.8,0,8.1s0.1,8.5,0.1,8.5l2.5,0.7c0,0,0.6-6.3,0.8-8.6 c0.2-2.3,0.9-8.8,1-9.2c0.1-0.3-0.1-3.6-1.8-3.8c-1.7-0.2-5.2-0.7-5.2-0.7L125.4,210z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M140,200.3c0,0-5.7,2.4-8.8,5.9c-3.1,3.5-4.2,4.9-8.2,4.6c-4-0.3-7.2-2.7-4.5-11.6l24-0.2L140,200.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M129,184.4c0,0,1.9,1.8,2.1,4.1c0.2,2.4-0.3,10.4-0.3,10.4l-3.1,0.1L129,184.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M129.3,198.8c0,0,0.5-4.7,0.8-9.2c0.2-2.2,0.1-4.7-1.6-6c-1.7-1.3-2.2-1.9-4-2.3c-1.7-0.3-5.2-0.3-5.2-0.3 s-2.9,1.1-3.5,1.6c-0.6,0.5,0.4,1.4,1,2.2c0.6,0.8,1.6,12.8,1.6,14.4C118.5,199.4,126.1,199.4,129.3,198.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M120.4,180.4c0,0,0.5,2.5,1.2,3.2s2.1,1.1,2.8,0.5c0.6-0.6,0.8-2.2,0.8-2.5s0.2-2.1,0.2-2.1L120.4,180.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M121.5,179.4c0,0,1.9,2.2,3.9,1.4c2.1-0.8,2.3-4,2.3-6.6s-5.6-0.7-5.6-0.7L121.5,179.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M114.2,185c0-0.4,1.5-1.5,2.4-1.3s1.4,0.6,1.6,1.7c0.2,1.1,0.4,5.1,0.4,6.2c0,1.1-0.2,3.2-0.2,3.2 s2.6,0.4,3.7,1.2c1.1,0.8,1.8,1.8,2.5,1.8c0.7,0,3.3-0.6,3.7,0c0.4,0.6,1.1,2.3,0.3,2.6s-3.3,0.8-3.5,0.2c-0.2-0.6-1.7-1.8-2.5-1.9 s-5-1.2-5.7-1.2C116.1,197.4,114.5,192.5,114.2,185z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M129.2,171.9c0,0,0.6,1.8-0.5,3c-0.9,0.9-3.2,1-4.4,0.4c-0.7-0.4-1.5-0.3-1.7,0.2c-0.3,0.5,0.5,4.3-1.1,5.3 c-1.6,1-7.2,1.1-7.8,7.8c0,0,0-4.7-0.8-4.5c-0.8,0.2-1.8,2-1.8,2s-1.5-6,0.6-7.7c3.2-2.7,3.5-0.7,6.2-2.8c2.5-2,1.9-4.8,5.2-5.7 C125.9,169.2,128.8,170.3,129.2,171.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "130.4,190.5 143.7,190.5 142.4,199.8 129,199.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M133.9,226.5c0,0-2,1.9,0,2.8c2,0.9,6.3,1.5,6.7,0.9c0.4-0.6,0.4-2.4-1.9-3 C136.4,226.6,136,227.1,133.9,226.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M145.7,219c0,0-0.3,4,1.7,3.1c2.1-0.9,5.3-2.2,5.9-3.1c0.6-0.9,0.6-1.9-0.7-1.8c-1.3,0.1-2.9,0.3-2.9,0.3 S149.6,218.8,145.7,219z"
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8248 -0.5654 0.5654 0.8248 -45.9566 144.2237)",
    className: "st15",
    cx: 209.7,
    cy: 146.3,
    rx: 11.3,
    ry: 15.1
  })), /*#__PURE__*/React.createElement("g", {
    className: "st40"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "SVGID_1_",
    transform: "matrix(0.8248 -0.5654 0.5654 0.8248 -45.972 144.1741)",
    className: "st40",
    cx: 209.7,
    cy: 146.3,
    rx: 11.3,
    ry: 15.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013879594565740502870000000372243578649089439_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 208.4,
    y: 130.3,
    style: {
      clipPath: "url(#SVGID_00000013879594565740502870000000372243578649089439_)",
      fill: "#FFFFFF"
    },
    width: 2.6,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.2,
    y: 131.2,
    style: {
      clipPath: "url(#SVGID_00000013879594565740502870000000372243578649089439_)",
      fill: "#FFFFFF"
    },
    width: 3.7,
    height: 32
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.1bb949e9773019c151b62e73afdb6044.svg";
export { ForwardRef as ReactComponent };